import { render, staticRenderFns } from "./postPinterest.vue?vue&type=template&id=3a9bbbc1"
import script from "./postPinterest.vue?vue&type=script&lang=js"
export * from "./postPinterest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a9bbbc1')) {
      api.createRecord('3a9bbbc1', component.options)
    } else {
      api.reload('3a9bbbc1', component.options)
    }
    module.hot.accept("./postPinterest.vue?vue&type=template&id=3a9bbbc1", function () {
      api.rerender('3a9bbbc1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/standardTab/renderPost/postPinterest.vue"
export default component.exports